import services from '@/config/services'

export default class ClientiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.basePraticheUrl = `${services.ask_pratiche.url}`
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/clienti/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'code',
        label: 'Codice',
        // type: {
        //   isBoolean:true
        //   isCurrency:true
        //   isDate: true
        // },
        default: true,
      },
      {
        property: 'ragsoc',
        label: 'Nome',
        sortable: true,
        default: true,
      },
      {
        property: 'codfis',
        label: 'C.Fiscale',
        sortable: true,
        default: true,
      },
      {
        property: 'piva',
        label: 'P.iva',
        sortable: true,
        default: true,
      },
      {
        property: 'codiceDestinatario',
        label: 'Codice Destinatario',
        sortable: true,
        default: true,
      },
      {
        property: 'rappresentante',
        label: 'Rappresentante',
        sortable: true,
        default: true,
      },
      {
        property: 'comune',
        label: 'Comune',
        sortable: true,
        default: true,
      },
      {
        property: "indirizzo_completo",
        label: "Indirizzo",
        default: true,
      },
      {
        property: "tipologia",
        label: "Tipologia",
        sortable: true,
        default: true,
      },
      {
        property: "fatturato",
        label: "Fatturato",
        type: {
          isCurrency:true
        },
        sortable: true,
        default: true,
      },
      {
        property: "pagato",
        label: "Pagato",
        type: {
          isCurrency:true
        },
        sortable: true,
        default: true,
      },
      {
        property: "saldo",
        label: "Saldo",
        type: {
          isCurrency:true
        },
        sortable: true,
        default: true,
      },
    ]
  }

  async getDettaglioCliente(id){
    let item = {}

    const url = `${this.baseUrl}/clienti/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/clienti/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async updateContact(contact, idRapp){
    const url = `${this.baseUrl}/clienti/rappresentanti/contact/update`

    try {
      const res = await this.http.post(url, {contact, idRapp})
      if (res.data.success) {
        this.eventBus.emit('data-load-success', {message: res.data.msg})
        return true
      }
      this.eventBus.emit('data-load-error', {message: res.data.msg || 'Modifica del contatto non salvata', url})
      return false
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return false
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async existCallCreditCheck(fd){
    let items = []
    const url = `${this.basePraticheUrl}/exist-credit-check`

    try {
      let res = await this.http.post(url, fd)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async callCreditCheck(fd){
    let items = []
    const url = `${this.basePraticheUrl}/get-credit-check`

    try {
        let res = await this.http.post(url, fd)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items
        }
    }
  }
  async getSDI(){
    let items = []
    const url = `${this.basePraticheUrl}/get-sdi`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async setMassivoSDI(clienti,sdi){
    let items = []
    const url = `${this.baseUrl}/clienti/set-sdi`

    try {
        let res = await this.http.post(url, {'sdi':sdi, 'clienti': clienti})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items
        }
    }
  }


  async getPreavvisiInfo(idCliente) {
    let items = []
    const url = `${this.baseUrl}/clienti/${idCliente}/preavvisi-info`

    try {
      let res = await this.http.get(url)
      items = res.data.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')     
    }
    
    return {
      items
    }
  }

  async getStorniInfo(idCliente) {
    let items = []
    const url = `${this.baseUrl}/clienti/${idCliente}/storni-sent-info`

    try {
      let res = await this.http.get(url)
      items = res.data.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')   
    }
    
    return {
      items
    }
  }

  async getSummaryProvvigioniCliente(clienteId, typeView, typeGroup, years){
    let items = {}

    const url = `${this.basePraticheUrl}/provvigioni/riepilogo/cliente`
    try {
      let res = await this.http.post(url, {
        clienteId,
        typeView,
        typeGroup,
        years
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }
}
